import React, { useState } from "react";
import { GlassCard } from "../components/GlassCard";

export const ContactPage = ({ c, isDark }) => {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const bgDot = isDark
    ? "radial-gradient(rgba(255,255,255,0.04) 1px, transparent 1px)"
    : "radial-gradient(rgba(0,0,50,0.06) 1px, transparent 1px)";

  const inputStyle = {
    width: "100%",
    background: isDark ? c.surfaceContainerLow : "#f0f2ff",
    borderBottom: `2px solid ${isDark ? c.outlineVariant : "#c4c6db"}`,
    borderTop: "none", borderLeft: "none", borderRight: "none",
    color: c.onSurface, padding: "12px 16px",
    fontFamily: "'Geist', sans-serif", fontSize: 16,
    transition: "border-color 0.3s",
  };

  return (
    <div style={{ background: c.background, minHeight: "100vh", backgroundImage: bgDot, backgroundSize: "32px 32px", paddingTop: 120 }}>
      <div style={{ position: "absolute", top: 180, left: -80, width: 384, height: 384, background: `${c.primary}12`, borderRadius: "50%", filter: "blur(60px)", pointerEvents: "none" }} />
      <div style={{ position: "absolute", bottom: 80, right: -80, width: 384, height: 384, background: `${c.primary}08`, borderRadius: "50%", filter: "blur(60px)", pointerEvents: "none" }} />

      <div style={{ maxWidth: 1280, margin: "0 auto", padding: "48px 64px 120px", position: "relative" }}>
        <div style={{ display: "grid", gridTemplateColumns: "5fr 7fr", gap: 32, alignItems: "flex-start" }}>
          <div>
            <GlassCard isDark={isDark} style={{ borderRadius: 16, overflow: "hidden" }}>
              <div style={{
                padding: "12px 16px", display: "flex", alignItems: "center", gap: 8,
                background: isDark ? c.surfaceContainerHighest : "#e8eaf8",
                borderBottom: `1px solid ${isDark ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.06)"}`,
              }}>
                {["#ff5f56", "#ffbd2e", "#27c93f"].map(bg => (
                  <div key={bg} style={{ width: 12, height: 12, borderRadius: "50%", background: bg }} />
                ))}
                <span style={{ marginLeft: 16, fontFamily: "'JetBrains Mono', monospace", fontSize: 12, color: c.outline, opacity: 0.7 }}>bash — whoami</span>
              </div>
              <div style={{ padding: 24, fontFamily: "'JetBrains Mono', monospace", fontSize: 14, color: c.onSurfaceVariant, lineHeight: 1.6 }}>
                <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
                  <span style={{ color: c.primary, fontWeight: 700 }}>~</span>
                  <span style={{ color: c.secondary }}>whoami</span>
                </div>
                <p style={{ marginBottom: 24 }}>
                  I am a <span style={{ color: c.secondary, fontWeight: 700 }}>Full-Stack Engineer</span> specialized in building high-performance, scalable distributed systems. My focus lies at the intersection of technical precision and elegant UX.
                </p>
                <div style={{ display: "flex", gap: 8, marginBottom: 8 }}>
                  <span style={{ color: c.primary, fontWeight: 700 }}>~</span>
                  <span style={{ color: c.secondary }}>ls -a ./socials</span>
                </div>
                <ul style={{ listStyle: "none", marginTop: 16 }}>
                  {[
                    { icon: "alternate_email", label: "Email", value: "root@syntax-err.dev" },
                    { icon: "terminal", label: "GitHub", value: "github.com/syntax-err" },
                    { icon: "hub", label: "LinkedIn", value: "linkedin.com/in/syntaxerr" },
                  ].map(({ icon, label, value }) => (
                    <li key={label} style={{
                      display: "flex", alignItems: "center", gap: 12, padding: "8px 8px",
                      borderRadius: 8, cursor: "pointer", marginBottom: 4, transition: "background 0.2s",
                    }}
                      onMouseEnter={e => e.currentTarget.style.background = isDark ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.04)"}
                      onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                    >
                      <span className="material-symbols-outlined" style={{ color: c.primary }}>{icon}</span>
                      <div>
                        <span style={{ display: "block", fontSize: 10, color: c.outline, textTransform: "uppercase", letterSpacing: "0.1em", fontWeight: 700 }}>{label}</span>
                        <span style={{ color: c.onSurface, fontSize: 14 }}>{value}</span>
                      </div>
                    </li>
                  ))}
                </ul>
                <div style={{ display: "flex", gap: 8, marginTop: 24, animation: "pulse 2s infinite" }}>
                  <span style={{ color: c.primary, fontWeight: 700 }}>~</span>
                  <div style={{ width: 8, height: 18, background: c.primary }} />
                </div>
              </div>
            </GlassCard>

            <GlassCard isDark={isDark} style={{ borderRadius: 16, padding: 24, marginTop: 16 }}>
              <h3 style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 12, color: c.outline, textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 16 }}>System Status</h3>
              {[
                { label: "Availability", value: "OPEN FOR PROJECTS", color: c.primary, pulse: true },
                { label: "Timezone", value: "UTC-05 (EST)", color: c.onSurface, pulse: false },
              ].map(({ label, value, color, pulse }) => (
                <div key={label} style={{
                  display: "flex", justifyContent: "space-between", alignItems: "center",
                  padding: "10px 0", borderBottom: `1px solid ${isDark ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.05)"}`,
                }}>
                  <span style={{ fontFamily: "'Geist', sans-serif", fontSize: 16, color: c.onSurface, opacity: 0.7 }}>{label}</span>
                  <span style={{ display: "flex", alignItems: "center", gap: 8, color, fontWeight: 700, fontFamily: "'JetBrains Mono', monospace", fontSize: 13 }}>
                    {pulse && (
                      <span style={{ position: "relative", width: 8, height: 8, display: "inline-block" }}>
                        <span style={{ position: "absolute", inset: 0, borderRadius: "50%", background: c.primary, opacity: 0.75, animation: "ping 2s infinite" }} />
                        <span style={{ position: "relative", display: "block", width: 8, height: 8, borderRadius: "50%", background: c.primary }} />
                      </span>
                    )}
                    {value}
                  </span>
                </div>
              ))}
            </GlassCard>
          </div>

          <div>
            <div style={{ marginBottom: 40 }}>
              <h1 style={{ fontFamily: "'Geist', sans-serif", fontWeight: 700, fontSize: "clamp(36px,5vw,64px)", color: c.onSurface, lineHeight: 1.1, letterSpacing: "-0.02em", marginBottom: 16 }}>
                Initialize{" "}
                <span style={{ background: `linear-gradient(135deg, ${c.primary}, ${c.secondary})`, WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>
                  Connection
                </span>
              </h1>
              <p style={{ fontFamily: "'Geist', sans-serif", fontSize: 18, color: c.onSurfaceVariant, maxWidth: 480, lineHeight: 1.6 }}>
                Have a high-scale architectural challenge or a complex product to build? Send a message to start the handshake protocol.
              </p>
            </div>

            <GlassCard isDark={isDark} style={{ borderRadius: 20, padding: "40px 48px" }}>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24, marginBottom: 24 }}>
                {[
                  { label: "Identification", key: "name", placeholder: "Your Name", type: "text" },
                  { label: "Protocol (Email)", key: "email", placeholder: "email@provider.com", type: "email" },
                ].map(({ label, key, placeholder, type }) => (
                  <div key={key}>
                    <label style={{ display: "block", fontFamily: "'JetBrains Mono', monospace", fontSize: 11, color: c.outline, textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 8 }}>{label}</label>
                    <input
                      type={type} placeholder={placeholder} value={form[key]}
                      onChange={e => setForm(prev => ({ ...prev, [key]: e.target.value }))}
                      style={inputStyle}
                      onFocus={e => e.target.style.borderBottomColor = c.primary}
                      onBlur={e => e.target.style.borderBottomColor = isDark ? c.outlineVariant : "#c4c6db"}
                    />
                  </div>
                ))}
              </div>
              <div style={{ marginBottom: 24 }}>
                <label style={{ display: "block", fontFamily: "'JetBrains Mono', monospace", fontSize: 11, color: c.outline, textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 8 }}>Subject</label>
                <input type="text" placeholder="Project Inquiry / Feedback / Hello" value={form.subject}
                  onChange={e => setForm(prev => ({ ...prev, subject: e.target.value }))}
                  style={inputStyle}
                  onFocus={e => e.target.style.borderBottomColor = c.primary}
                  onBlur={e => e.target.style.borderBottomColor = isDark ? c.outlineVariant : "#c4c6db"}
                />
              </div>
              <div style={{ marginBottom: 32 }}>
                <label style={{ display: "block", fontFamily: "'JetBrains Mono', monospace", fontSize: 11, color: c.outline, textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 8 }}>Payload (Message)</label>
                <textarea placeholder="Describe the project scope or message content..." rows={5} value={form.message}
                  onChange={e => setForm(prev => ({ ...prev, message: e.target.value }))}
                  style={{ ...inputStyle, resize: "none" }}
                  onFocus={e => e.target.style.borderBottomColor = c.primary}
                  onBlur={e => e.target.style.borderBottomColor = isDark ? c.outlineVariant : "#c4c6db"}
                />
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 16 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8, color: c.error }}>
                  <span className="material-symbols-outlined" style={{ fontSize: 16 }}>info</span>
                  <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 12, textTransform: "uppercase" }}>Mandatory fields required for handshake</span>
                </div>
                <button style={{
                  padding: "14px 48px", borderRadius: 9999, border: "none", cursor: "pointer",
                  background: `linear-gradient(135deg, ${c.primaryContainer}, ${c.secondaryContainer})`,
                  color: "#fff", fontFamily: "'Geist', sans-serif", fontWeight: 600, fontSize: 16,
                  display: "flex", alignItems: "center", gap: 12, transition: "all 0.3s",
                }}
                  onMouseEnter={e => { e.currentTarget.style.transform = "scale(1.05)"; e.currentTarget.style.boxShadow = `0 8px 32px ${c.primary}40`; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = "scale(1)"; e.currentTarget.style.boxShadow = "none"; }}
                >
                  <span>EXECUTE SEND</span>
                  <span className="material-symbols-outlined">send</span>
                </button>
              </div>
            </GlassCard>
          </div>
        </div>
      </div>
    </div>
  );
};